import { environment } from '@admin-env/environment';
import { Resource } from '@admin-shared/models/resource';

export class ResourceMapper {
  public static mapItems(resources: Resource[]): Resource[] {
    return resources.map(ResourceMapper.mapItem);
  }
  public static mapItem(resource: Resource): Resource {
    if (!resource.thumbnailUrl) return resource;
    const assetUrl = `${environment.ASSETS_URL}/${resource.thumbnailUrl}`;
    resource.asset = {
      auctionId: `${resource.resourceCategoryId}`,
      name: resource.thumbnailUrl,
      url: resource.thumbnailUrl,
      imageUrl: assetUrl,
    };
    return resource;
  }
}
